import { ApiCallError } from './ApiCallError';
import { notifyApiCallError } from './notifyApiCallError';

type TRejectionEvent = { reason: unknown; preventDefault: () => void };

export const handleUnhandledApiCallRejection = (event: TRejectionEvent): boolean => {
  const { reason } = event;
  if (!(reason instanceof ApiCallError)) {
    return false;
  }
  event.preventDefault();
  notifyApiCallError(reason);
  return true;
};
